/* eslint-disable no-plusplus */
import { pascalize } from "humps";
import {
  emptyTextCell,
  nonEditable,
  textCell,
  getHeaderRow,
  chevronCell
} from "../cells";
import { HEADING_ROW_HEIGHT } from "../constants";
import { formatCurrency } from "@/utils/helpers";

export const CASHINCHANGE_ROW_ID = "cashInChange";

const transformAccountsToRows = (accounts, parentId = null, rowId = 0) => {
  let rId = rowId;
  let rows = [];
  accounts.forEach((account, index) => {
    const currentRowId = rId + index;
    const hasChildren = account.accounts && account.accounts.length > 0;
    const balanceText = account.balance ;
    const row = {
      rowId: currentRowId,
      height: HEADING_ROW_HEIGHT,
      cells: [
        chevronCell({
          text: account.groupHeader || account.name,
          parentId,
          isExpanded: true,
          hasChildren
        }),
        nonEditable(textCell({ text: `${formatCurrency(balanceText)}` }), "font-bold trial-balance-row justify-content-start")
      ]
    };
    rows.push(row);

    if (hasChildren) {
      const { rows: childRows } = transformAccountsToRows(account.accounts,
        currentRowId,
        currentRowId + 1);
      rows = rows.concat(childRows);
      rId += childRows.length;
    }
  });

  return { rows, rowId: rId };
};

function getAccountsRows(title, rowsData, parentId = null) {
  const result = [];
  let rowNumber = 0;
  console.log("rowsData", rowsData);
  const titleRow = [
    {
      rowId: `${title}${++rowNumber}`,
      height: HEADING_ROW_HEIGHT,
      cells: [
        chevronCell({
          text: title,
          parentId,
          isExpanded: true,
          hasChildren: true
        }),
        nonEditable(textCell({ text: `${formatCurrency(rowsData?.balance || 0)}` }), "font-bold trial-balance-row justify-content-start"),

      ]
    },
  ];

  if (rowsData) {
    const { rows: accountsRows, rowId } = transformAccountsToRows(rowsData?.accounts,
      `${title}${1}`,
      `${title}${++rowNumber}`);
  
    result.push(...titleRow, ...accountsRows,);
    rowNumber = rowId;
  }
  return result;
}

function formatString(inputString) {
  return inputString.replace(/([A-Z])/g, " $1").trim();
}

function getTopParent(title, total = 0) {
  let rowNumber = 0;
  if (title) {
    const tempArr = ({
      rowId: `${title}${++rowNumber}`,
      height: HEADING_ROW_HEIGHT,
      cells: [
        chevronCell({
          text: formatString(pascalize(title)),
          parentId: null,
          isExpanded: true,
          hasChildren: true
        }),
        nonEditable(textCell({ text: formatCurrency(total) }), "font-bold trial-balance-row justify-content-start"),
      ]
    });

    return tempArr;
  }

  return {};
}

function getTotalRow(title, amount, parentId = null) {
  let rowNumber = 0;
  if (title) {
    const tempArr = ({
      rowId: `${title}${++rowNumber}`,
      height: HEADING_ROW_HEIGHT,
      cells: [
        chevronCell({
          text: formatString(pascalize(title)),
          parentId,
          hasChildren: false,
          className: "font-bold trial-balance-row justify-content-start total-row"
        }),
        nonEditable(textCell({ text: formatCurrency(amount) }), "font-bold trial-balance-row justify-content-start total-row"),
      ]
    });

    return tempArr;
  }

  return {};
}

export function getBalanceSheetRows({
  data,
  columns
}) {

  if (data.data.length === 0) {
    return [];
  }

  const {
    assets,
    totalAssets,
    netIncome,
    liabilities,
    totalLiabilities,
    totalEquity,
    equity,
    netAssets
  } = data.data;
  const { currentAssets, nonCurrentAssets } = assets;
  const { nonCurrentLiabilities, currentLiabilities, } = liabilities;
  const { equity: equityData } = equity;
  // assets
  const assetsRow = getTopParent("Assets",totalAssets.total.balance);
  const currentAssetRows = getAccountsRows("Current Assets", currentAssets, assetsRow.rowId);
  const nonCurrentAssetRows = getAccountsRows("Non Current Assets", nonCurrentAssets, assetsRow.rowId);

  // liabilities
  const liabilitiesRow = getTopParent("Liabilities",totalLiabilities.total.balance);
  const nonCurrentLiabilitiesRow = getAccountsRows("Non Current Liabilities", nonCurrentLiabilities, liabilitiesRow.rowId);
  const currentLiabilitiesRow = getAccountsRows("Current Liabilities", currentLiabilities, liabilitiesRow.rowId);

  // netAssets
  const netAssetsRow = getTopParent("Net Assets",netAssets.netAssets.accounts[0].netActivity);

  // equity
  const equityRow = getTopParent("Equities", totalEquity.total.balance);
  const equityRows = getAccountsRows("Equity", equityData, equityRow.rowId);

  return [getHeaderRow(columns),
    // assets
    assetsRow,
    ...nonCurrentAssetRows,
    ...currentAssetRows,
    liabilitiesRow,
    ...nonCurrentLiabilitiesRow,
    ...currentLiabilitiesRow,
    netAssetsRow,
    // equity
    equityRow,
    ...equityRows,
  ];

}